<template>
  <v-overlay
    v-model="dialogVisibility"
    :color="overlayColor"
    opacity="0.92"
    :style="{ top: `${appBarHeight}px`, height: `calc(100vh - ${appBarHeight}px)`, zIndex: overlayZIndex }"
  >
    <v-container @keydown.enter="confirm">
      <div class="model-main-loader">
        <DefaultLoading v-if="loading" :loading="loading" />
      </div>
      <v-row class="pa-2 text-center">
        <div>
          <div v-if="error" class="col-sm-12 col-md-12">
            <v-alert class="mt-5 red" border="left" text>
              {{ errorMsg }}
            </v-alert>
          </div>
          <div class="col-12" :style="{ color: textColor }">
            <strong>{{ $t("and_we_are_almost_there") }}</strong>
            <p>{{ $t("draw_your_signature_here") }}</p>
          </div>
          <div class="signature-pad">
            <div class="col-sm-12 pb-5">
              <VueSignaturePad
                id="signature"
                width="100%"
                height="280px"
                ref="signaturePad"
                :options="options"
              />
            </div>

            <div class="row">
              <div class="col-4 text-left">
                <v-btn color="#817975" @click="undo">{{ $t("clean") }}</v-btn>
              </div>
              <div class="col-4 signature-above">
                {{ $t("signature_above") }}
              </div>
              <div class="col-4 text-right">
                <v-btn
                  @click="confirm()"
                  :style="{ backgroundColor: buttonColor, color: buttonTextColor }"
                >
                  {{ $t("save") }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>
import DefaultLoading from "../../components/multiple/shared/DefaultSignLoading.component";

export default {
  name: "sign-confirm-pad-modal",
  components: { DefaultLoading },
  props: {
    dialog: Boolean,
    error: Boolean,
    errorMsg: String,
  },
  data: () => ({
    loading: false,
    options: {
      penColor: "#0A3D91",
      padImage: "",
    },
    dialogVisibility: false, // local v-model to avoid mutating prop
    appBarHeight: 0,
    overlayZIndex: 1, // por defecto bajo la appBar; ajusta si tu appBar tiene un z-index mayor
  }),
  computed: {
    overlayColor() {
      return this.$store.state.common.footerColor;
    },
    buttonColor() {
      return this.$store.state.common.footerColor;
    },
    buttonTextColor() {
      return this.$store.state.common.footerTextColor;
    },
    textColor() {
      return this.$store.state.common.footerTextColor;
    },
  },
  watch: {
    // cuando la prop cambie (el padre abre/cierra), sincronizamos
    dialog(val) {
      this.dialogVisibility = val;
      if (val) {
        this.computeAppBarHeight();
      }
    },
    // cuando el local cambia (por ejemplo cerramos desde aquí), notificamos al padre
    dialogVisibility(val) {
      if (!val) {
        // emitimos evento v-model-compatible para que el padre cierre la prop
        this.$emit("update:dialog", false);
      }
    },
  },
  mounted() {
    this.computeAppBarHeight();
    window.addEventListener("resize", this.computeAppBarHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.computeAppBarHeight);
  },
  methods: {
    computeAppBarHeight() {
      // ajusta los selectores si tu appBar tiene otra clase/id
      const selectors = [".v-app-bar", ".app-bar", "header.v-toolbar", "header"];
      let el = null;
      for (const sel of selectors) {
        el = document.querySelector(sel);
        if (el) break;
      }
      const fallback = 64;
      const height = el ? Math.round(el.getBoundingClientRect().height) : fallback;
      this.appBarHeight = height;

      // Si tu appBar usa un z-index alto y el overlay aparece por encima,
      // asegúrate de establecer overlayZIndex a un valor menor que el z-index del appBar.
      // Por ejemplo, si tu appBar tiene z-index: 10 -> overlayZIndex = 5
      // Aquí dejamos 1 por defecto, cámbialo si es necesario.
    },

    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    confirm() {
      this.loading = true;
      const { data } = this.$refs.signaturePad.saveSignature();
      this.padImage = data;

      this.$emit("submitSignPad", this.padImage); // enviar imagen al padre
      // cerramos localmente (esto disparará el watcher que emite update:dialog)
      this.dialogVisibility = false;

      this.loading = false;
    },

    reset() {
      this.padImage = "";
    },
  },
};
</script>

<style>
#signature {
  border: 1px solid #cdbfbf;
  border-radius: 5px;
}

.container {
  width: 100%;
  padding: 8px 16px;
}

.signature-pad {
  background: white;
  padding: 15px 15px;
  border-radius: 7px;
  width: 100%;
}

.signature-pad .signature-above {
  color: #cecece;
}
</style>
